import React, { useEffect, useState, useRef } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import {
    Insert as ADD,
    Update as UPDATE,
    Delete as DELETE,
    Select as SELECT,
    SelectByID as SELECT_BY_ID
} from 'Components/Api/UserWiseLatLongAPI';
import {
    Container,
    Grid,
    MenuItem,
    Paper
} from '@material-ui/core';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { SelectForDropDown as PROVIDER_DROP_DOWN } from 'Components/Api/ProviderApi';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import ReactTable from 'Components/ReactTable/ReactTable';
import { RETAILER } from 'Components/Helper/UsertypeCode';
import HOCLoader from 'Components/Loader/HOCLoader';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SelectUserForDropDown as USER_SELECT_FOR_DROPDOWN } from 'Components/Api/UsersApi';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import {
    PLEASE_PROVIDE_VALID,
} from 'Components/Helper/Messages';

const CustomContainer = HOCLoader(Container);
export const UserWiseLatLong = () => {
    const [itemList, setItemList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [downline, setDownline] = useState([]);
    const [IsFetchAllList, setisFetchAllList] = useState(false);
    const [providerList, setProviderList] = useState([]);
    const [userList, setUserList] = useState([]);
    const formRef = useRef();
    const [userWiseLatLongID, setUserWiseLatLongID] = useState(0);
    const [isUpdate, setIsUpdate] = useState(false);
    const [currentUserTypeID, setCurrentUserTypeID] = useState(
        parseInt(localStorage.getItem('UserTypeID'))
    );
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'All User'
    });

    const [formObject, setFormObject] = useState({
        UserID: 0,
        User: userDefault,
        ProviderID: 0,
        ProviderName: '',
        UserName: '',
        Latitude: '',
        Longitude: ''
    });

    const ValidationSchema = Yup.object({
        Latitude: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'Latitude')
            .length(15, PLEASE_PROVIDE_VALID + 'Latitude'),

        Longitude: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'Longitude')
            .length(15, PLEASE_PROVIDE_VALID + 'Longitude')
    });

    useEffect(() => {
        setLoadingOpen(true);
        select();
        createColumns();
        fetchUserList();
        selectProvider();
    }, []);

    const onDeleteClick = (item) => {
        var RequestObj = { UserWiseLatLongID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const selectProvider = async () => {
        setLoadingOpen(true);
        const response = await PROVIDER_DROP_DOWN();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);
        setProviderList(data);
    };

    const fetchUserList = async () => {
        setLoadingOpen(true);
        const response = await USER_SELECT_FOR_DROPDOWN();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);
        setUserList(data);
    };

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        SelectUser(text);
    };

    const isValidToRefreshList = (list) => {
        if (IsFetchAllList === false) {
            return true;
        }

        if (list === undefined || list === null) {
            return true;
        }

        if (list.length <= 1) {
            return true;
        }

        return false;
    };

    const SelectUser = async (text) => {
        if (RETAILER === parseInt(currentUserTypeID)) {
            let objWithSelectAll = [userDefault];
            setDownline(objWithSelectAll);
            return;
        }
        var jsonObj = {
            FirmName: text
        };

        if (isValidToRefreshList(downline) === false) {
            return;
        }

        setLoadingOpen(true);
        var request = JSON.stringify(jsonObj);
        const userResponse = await USER_SELECT_FOR_DROPDOWN(request);

        setLoadingOpen(false);
        if (!userResponse.isAuthorized) LOGOUT();

        if (!userResponse.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(userResponse.data);

        let objWithSelectAll = [userDefault, ...data];

        setDownline(objWithSelectAll);
    };
    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);
        setLoadingOpen(true);
        const response = await DELETE(jsonReq);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) setSeverity('error');

        select();
    };

    const DeleteConfirmationModal = isAlertOpen ? (
        <ConfirmAlert
            isOpen={isAlertOpen}
            title="Delete Confirmation"
            message="Are you sure to delete this userwise latitude longitude."
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpen(false);
                Delete(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpen(false);
            }}
        />
    ) : null;

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        if (loadingOpen) {
            setLoadingOpen(false);
            return;
        } 
        const request = {
            UserID: values.User.UserID,
            ProviderID: values.ProviderID,
            Latitude: values.Latitude,
            Longitude: values.Longitude
        }; 
        var requestObj = JSON.stringify(request); 
        var requestObjAdd = JSON.stringify(values);

        setLoading(true);
        setIsError(false);
        setSubmitting(false);

        var response = isUpdate
            ? await UPDATE(requestObjAdd)
            : await ADD(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setSubmitting(true);
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            return;
        }
        resetForm(formObject);
        setFormObject({
            UserID: 0,
            ProviderID: 0,
            Latitude: 0,
            Longitude: 0
        });
        select();
    };

    const select = async () => {
        setItemList([]);
        setLoadingOpen(true);
        const response = await SELECT();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        const data = JSON.parse(response.data);
        setItemList(data);
    };

    const createColumns = () => {
        var columns = [];
        columns.push({
            label: '#',
            name: 'UserWiseLatLongID',
            srno: true
        });
        columns.push({
            label: 'User',
            name: 'UserName'
        });
        columns.push({
            label: 'Provider',
            name: 'ProviderName'
        });
        columns.push({
            label: 'Latitude',
            name: 'Latitude',
        });
        columns.push({
            label: 'Longitude',
            name: 'Longitude',
        });

        columns.push({
            label: 'Edit',
            name: 'UserWiseLatLongID',
            edit: true,
            callback: (value) => {
                Edit(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'UserWiseLatLongID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };

    const Edit = async (UserWiseLatLongID) => {
        setIsUpdate(true);
        selectByID(UserWiseLatLongID);
    };

    const selectByID = async (UserWiseLatLongID) => {
        let JSONObj = {
            UserWiseLatLongID: UserWiseLatLongID
        };
        setUserWiseLatLongID(UserWiseLatLongID);
        var request = JSON.stringify(JSONObj);
        setLoadingOpen(true);
        const response = await SELECT_BY_ID(request); 
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT(); 
        var data = JSON.parse(response.data); 
        setIsUpdate(true);

        setFormObject({
            User: {
                UserID: data.UserID,
                UserName: data.UserName
            },
            ProviderID: data.ProviderID,
            ProviderName: data.ProviderName,
            Latitude: data.Latitude,
            Longitude: data.Longitude
        });
        if (formRef.current) {
            formRef.current.setValues({
                ...data,
                User: {
                    UserID: data.UserID, UserName: data.UserName
                }
            });
        }
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                initialValues={formObject}
                resetForm={formObject}
                onSubmit={handleSubmit} 
                validationSchema={ValidationSchema}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                UserWise Latitude Longitude
                            </h2>

                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={10}
                                            sm={10}
                                            md={2}
                                            lg={2}
                                        >
                                            <Field
                                                component={AsyncAutoComplete}
                                                defaultValue={userDefault}
                                                FieldName="User"
                                                name="User"
                                                SubFieldName="UserID"
                                                options={userList}
                                                getOptionLabel={(option) =>
                                                    option.FirmName
                                                }
                                                textFieldProps={{
                                                    label: 'Select User'
                                                }}
                                                onSearchCallback={(text) => {
                                                    callSearch(
                                                        text,
                                                        values.UserTypeID
                                                    );
                                                }}
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    setUserDefault({
                                                        UserID: value.UserID,
                                                        FirmName: value.FirmName
                                                    });
                                                }}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Provider"
                                                name="ProviderID"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Provider
                                                </MenuItem>
                                                {providerList.map(
                                                    (
                                                        {
                                                            ProviderID,
                                                            ProviderName
                                                        },
                                                        index
                                                    ) => (
                                                        <MenuItem
                                                            key={index}
                                                            value={ProviderID}
                                                        >
                                                            {ProviderName}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <MaterialTextField
                                                label="Latitude"
                                                name="Latitude"
                                                type="text"
                                                length={15}
                                                placeholder="Latitude"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <MaterialTextField
                                                label="Longitude"
                                                name="Longitude"
                                                type="text"
                                                length={15}
                                                placeholder="Longitude"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={1}
                                            lg={1}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Add"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                Add
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={1}
                                            lg={1}
                                        >
                                            <SecondaryButton
                                                type="reset"
                                                variant="contained"
                                                color="secondary"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <h2 className={classes.PaperHead_h2}>UserWise latitude longitude Report</h2>

            <ReactTable
                data={itemList}
                columns={mainColumns}
                rowsPerPage={50}
                headerToolbar={false}
            />

            {DeleteConfirmationModal}

        </CustomContainer>
    );

};
